
export default class Login2024 {

    constructor() {
        this.init();
    }

    init() {
        if ($('.login2024-kont').length > 0)
        {
            $('.login2024-kont #login2form #jelszo').on('keyup', e => {
                if (e.keyCode == 13)
                {
                    $('.login2024-kont #login2form button').trigger('click')
                }
            });

            $('.login2024-kont #login2form button').on('click', e => {
                let email = $('.login2024-kont #login2form #email').val();
                let jelszo = $('.login2024-kont #login2form #jelszo').val();

                let error = this.loginformcheck();

                if (!error)
                {
                    $.post('/index.php/felhasznalok/loginservice/login', { email: email, kartyaszam: jelszo, forcelang: $('body').attr('data-aktlang') }, retlogin => {
                        if (retlogin.state == true)
                        {
                            window.location.reload()
                        } else {
                            $("div.errordiv").remove();
                            $(".errorredborder").removeClass("errorredborder");
                            $(".errordiv").text("");
                            if(!$(".errordiv").hasClass("hide")){
                                $(".errordiv").addClass("hide");
                            }
                            let errorobj = { "str": retlogin.msg, "obj": ".login2024-kont #login2form #jelszo" };
                            this.drawError(errorobj)

                        }
                    },'json')
                }
            })

            $('.login2024-kont .extra-login.google-btn a').on('click', e => {
                e.preventDefault();
                window.open($(e.currentTarget).data('open-frame-url'),'sharer','toolbar=0,status=0,width=630,height=630,scrollbars=yes');
            })

            if (typeof window.facebook_login_app_id != 'undefined')
            {
                this.fb_init();
            }

        }

        if (typeof window.google_showPopUp_window != "undefined")
        {
            this.google_showPopUp('/'+pageHandle+'?saveconnect=1&glogin=1');
        }

        if (typeof window.google_showPopUp_emptywindow != "undefined")
        {
            this.google_showPopUp('/'+pageHandle+'?emptypopoup=1');
        }
    }

    loginformcheck()
    {
        var error = false;
        var errorobj = [];

        if ($(".login2024-kont #login2form #email").val() == "")
        {
            error = true;
            errorobj.push({"str": lngMessages["Email nem lehet üres"], "obj": ".login2024-kont #login2form #email"});
        } else {
            let emailReg = /^\S+@\S+\.\S+$/;
            if (!emailReg.test($("[name='email']").val()))
            {
                error = true;
                errorobj.push({"str": lngMessages["Email cím nem tűnik érvényesnek"], "obj": ".login2024-kont #login2form #email"});
            }

        }

        if ($(".login2024-kont #login2form #jelszo").length>0){
            if ($(".login2024-kont #login2form #jelszo").val() == "")
            {
                error = true;
                errorobj.push({"str": lngMessages["Jelszó kötelező"], "obj": ".login2024-kont #login2form #jelszo"});
            }

        }

        if (error)
        {
            $("div.errordiv").remove();
            $(".errorredborder").removeClass("errorredborder");
            $(".errordiv").text("");
            if(!$(".errordiv").hasClass("hide")){
                $(".errordiv").addClass("hide");
            }

            for (const eobj of errorobj)
            {
                this.drawError(eobj)
            }
        }

        return error;
    }

    drawError(eobj)
    {
        if ($(eobj.obj).length > 0)
        {
            if ($(eobj.obj).prop('tagName').toLowerCase() == "select") {
                $(eobj.obj).parents('.loginformrow').find(".fancy-select-display").addClass("errorredborder")
            } else {

                $(eobj.obj).addClass("errorredborder");

                var par = $(eobj.obj).parents('.loginformrow');
                if (par.length > 0)
                {
                    if (par.hasClass('checkbox'))
                    {
                        $('<div>').addClass('errordiv hide').appendTo($(par).find('label'))
                    } else {
                        $('<div>').addClass('errordiv hide').appendTo($(par))
                    }
                }

                par.find(".errordiv").text(eobj.str).removeClass("hide")
            }
        }
    }

    fb_statusChangeCallback(response)
    {
        if (response.status === 'connected')
        {
            FB.api('/me', { fields: 'id, name, email, first_name, last_name' }, function(response) {

                response['method'] = 'check_login';
                $.post('/belepes/fb_login', response, function (res) {
                    document.location.reload(true);
                });
            });
        } else {
            console.log(response)
        }
    }


    fb_init() {

        window.fbAsyncInit = function () {

            FB.init({
                appId: window.facebook_login_app_id,
                cookie: true,
                version: 'v22.0'
            });


            // FB.getLoginStatus(function (response) {
            //     // belepes.fb_statusChangeCallback(response);
            // });

        };

        $('a#fblogout').on('click', e => {
            e.preventDefault()
            FB.logout(function (response) {

            });
        });

        $('.login2024-kont .extra-login.facebook-btn a').on('click', e => {
            e.preventDefault()

            FB.login(function (response) {
                if (response.status === 'connected') {
                    FB.api('/me', { fields: 'id, name, email, first_name, last_name' }, function(fbresp) {

                        if (typeof fbresp.email == 'string') {
                            let checkData = {
                                'mode': 'fb',
                                'email': fbresp.email,
                                'id': fbresp.id
                            };
                            $.get('/index.php/felhasznalok/loginservice/check_social_user_exists', checkData, function (stres) {
                                if (stres.exists) {
                                    window.Login2.fb_showPopUp(fbresp)
                                } else {
                                    fbresp['method'] = 'new_login';
                                    $.post('/'+pageHandle+'?step=2&fblogin=1', fbresp, function (res) {
                                        window.location.reload();
                                    });
                                }
                            });
                        }
                    });
                }
            }, {scope: 'public_profile,email'});
        })
    }

    fb_showPopUp(fbresp)
    {
        var popWindowOverlay = $('<div>').addClass('pms-overlay');
        popWindowOverlay.appendTo($('body'))
        var popWindow = $('<div>').addClass('pop-window');
        var popClose = $('<a>').addClass('pop-closeme').attr('href', '');
        popClose.on('click', e => {
            e.preventDefault();
            $(e.currentTarget).parents('.pop-window').remove();
            $('.pms-overlay').remove();
        });
        popClose.appendTo(popWindow);
        var popBody = $('<div>').addClass('pop-body');

        var popBodyHead = $('<div>').addClass('body-head').text(lngMessages["Szeretné összekötni a fiókjait?"]);
        popBodyHead.appendTo(popBody);

        if ($('html').data('disztributor') != 'de')
        {
            var popBodyMessage = $('<div>').addClass('body-message').text(lngMessages['Úgy tűnik ezekkel az adatokkal már korábban létrehozott egy Pödör fiókot. Szeretné, hogy csatoljuk a felhasználót?']);
            popBodyMessage.appendTo(popBody);
        }

        var popBodyFooter = $('<div>').addClass('body-footer');

            var popConfirmButton = $('<a>').addClass('btn btn-default-white').attr('href', '').text(lngMessages["Igen, a fiókok összekötése"]);

            popConfirmButton.on('click', e => {
                e.preventDefault();

                fbresp['method'] = 'new_login';
                $.post('/'+pageHandle+'?step=2&fblogin=1', fbresp, function (res) {
                    window.location.reload();
                });
            });
            popConfirmButton.appendTo(popBodyFooter);


        popBodyFooter.appendTo(popBody);

        popBody.appendTo(popWindow);

        popWindow.appendTo($('body'));

    }

    google_showPopUp(loginurl)
    {
        var popWindowOverlay = $('<div>').addClass('pms-overlay');
        popWindowOverlay.appendTo($('body'))
        var popWindow = $('<div>').addClass('pop-window');
        var popClose = $('<a>').addClass('pop-closeme').attr('href', '');
        popClose.on('click', e => {
            e.preventDefault();
            $(e.currentTarget).parents('.pop-window').remove();
            $('.pms-overlay').remove();
        });
        popClose.appendTo(popWindow);
        var popBody = $('<div>').addClass('pop-body');

        var popBodyHead = $('<div>').addClass('body-head').text(lngMessages["Szeretné összekötni a fiókjait?"]);
        popBodyHead.appendTo(popBody);

        if ($('html').data('disztributor') != 'de')
        {
            var popBodyMessage = $('<div>').addClass('body-message').text(lngMessages['Úgy tűnik ezekkel az adatokkal már korábban létrehozott egy Pödör fiókot. Szeretné, hogy csatoljuk a felhasználót?']);
            popBodyMessage.appendTo(popBody);
        }

        var popBodyFooter = $('<div>').addClass('body-footer');

            var popConfirmButton = $('<a>').addClass('btn btn-default-white').attr('href', loginurl).text(lngMessages["Igen, a fiókok összekötése"]);
            popConfirmButton.appendTo(popBodyFooter);


        popBodyFooter.appendTo(popBody);

        popBody.appendTo(popWindow);

        popWindow.appendTo($('body'));

    }

}

